<template>
	<div style="background-color: #E18738;height: 179px;text-align: center;">
		<img :src="require('@/assets/img/Online_customer.png')" style="width: 100px;height: 100px;margin-top: 40px;" />
	</div>
	<div>
		<div class="model"
			@click="this.$router.push({ path: '/customerService', query: { motoId: motoId,deptId: deptId }})"
			style="width: 92%; height: 103px; background-color: #FFF;border-radius: 8px;">
			<Row justify="center" class="code-row-bg">
				<img :src="require('@/assets/img/question.png')" style="width: 73px;height: 54px;margin-top: 24px;" />
				<div style="height: 54px;margin-left: 12px;">
					<div style="text-align: left;">
						<p style="margin-top: 5px;text-indent: 0em; font-size: 20px;color: #343A4A;margin-top: 24px;">
							{{ this.$t('msg.userCustomer') }}
						</p>
						<p style="text-indent: 0em; font-size: 14px;color: #9095A6;">
							{{ this.$t('msg.clickUserCustomer') }}</p>
					</div>
				</div>
			</Row>
		</div>
		<div class="model"
			@click="this.$router.push({ path: '/customerHistory', query: { motoId: motoId,deptId: deptId }})"
			style="width: 92%; height: 103px; background-color: #FFF;border-radius: 8px;">
			<Row justify="center" class="code-row-bg">
				<img :src="require('@/assets/img/Historical_records.png')"
					style="width: 73px;height: 54px;margin-top: 24px;" />
				<div style="height: 54px;margin-left: 12px;">
					<div style="text-align: left;">
						<p style="margin-top: 5px;text-indent: 0em; font-size: 20px;color: #343A4A;margin-top: 24px;">
							{{ this.$t('msg.historyRecord') }}
						</p>
						<p style="text-indent: 0em; font-size: 14px;color: #9095A6;">
							{{ this.$t('msg.clickHistoryRecord') }}</p>
					</div>
				</div>
			</Row>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				motoId: '',
				deptId: '',
			};
		},
		mounted() {
			this.motoId = this.$route.query.motoId;
			this.deptId = this.$route.query.deptId;

			document.querySelector('body').setAttribute('style', 'background-color:#eff2f5');
			document.title = this.$t('msg.customerTitle')
		}
	}
</script>

<style>
	.model {
		margin: 0px;
		padding: 0px;
		margin-top: 8px;
		margin-left: 4%;
		margin-right: 4%;
		text-align: center;
	}
</style>